import { IListElement } from '@/types';

export const NoActionsItem: IListElement = {
    label: 'Нет доступных действий',
    value: 'no_actions',
};
